import React, { useEffect, useRef, useState } from 'react';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import PrimeReact from 'primereact/api';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Tooltip } from 'primereact/tooltip';

import { useHistory } from 'react-router-dom';
import { useToast } from '../../../hooks/toast';
import { Container } from './styles';
import api from '../../../services/api';

 interface IResultProperties {
  resultado_id: number | null;
  resultado_descricao: string;
}

const Result: React.FC = () => {
  // active ripple effect
  PrimeReact.ripple = true;

  const emptyResult = {
    resultado_id: null,
    resultado_descricao: '',
  };

  const [results, setResults] = useState<IResultProperties[]>([]);
  const [result, setResult] = useState(emptyResult);
  const [deleteResult, setDeleteResultDialog] = useState(false);
  const [deleteResultsDialog, setDeleteResultsDialog] = useState(false);
  const [selectedResults, setSelectedResults] = useState<IResultProperties[]>([]);

  // para tabela
  const [globalFilter, setGlobalFilter] = useState('');
  const dt = useRef(null);
  const { addToast } = useToast();
  const history = useHistory();

  useEffect(() => {
    (async () => {
      const response = await api.get('/lawsuits/results/show/all');
      setResults(response.data);
    })();
  }, []);

  const columns = [
    { field: 'resultado_id', header: 'Código', sortable: true },
    { field: 'resultado_descricao', header: 'Descrição', sortable: true },
  ];

  const dynamicColumns = columns.map((col) => (
    <Column
      key={col.field}
      field={col.field}
      header={col.header}
      sortable
    />
  ));

  const handleCreate = () => {
    history.push('/lawsuit/result/create');
  };

  const hidedeleteResult = () => {
    setDeleteResultDialog(false);
  };

  const hidedeleteResultsDialog = () => {
    setDeleteResultsDialog(false);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const editResult = (rowData:any) => {
    history.push(`/lawsuit/result/edit/${rowData.resultado_id}`);
  };

  // eslint-disable-next-line @typescript-eslint/no-shadow
  const confirmDeleteResult = (result: React.SetStateAction<{
    resultado_id: null; resultado_descricao: string;
  }>) => {
    setResult(result);
    setDeleteResultDialog(true);
  };

  const deleteGroup = () => {
    api.delete(`/lawsuits/results/delete/${result.resultado_id}`);

    setDeleteResultDialog(false);

    const updatedRecords = results
      .filter((val) => val.resultado_id !== result.resultado_id);
    setResults(updatedRecords);

    addToast({
      type: 'success',
      title: 'Cadastro excluído!',
      description:
        'O cadastro selecionado foi excluído com sucesso!',
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const actionBodyTemplate = (rowData: any) => (
    <>
      <Button
        type="button"
        icon="pi pi-pencil"
        tooltip="Alterar cadastro"
        tooltipOptions={{ position: 'left' }}
        className="p-button-rounded p-button-text p-button-plain p-mr-2"
        onClick={() => { editResult(rowData); }}
      />
      <Button
        type="button"
        icon="pi pi-trash"
        tooltip="Excluir cadastro"
        tooltipOptions={{ className: 'red-tooltip', position: 'left' }}
        className="p-button-rounded p-button-text p-button-plain"
        onClick={() => { confirmDeleteResult(rowData); }}
      />
    </>
  );

  const header = (
    <div className="flex align-items-center export-buttons">
      <Button
        type="button"
        label="Novo"
        icon="pi pi-plus"
        className="p-button-primary p-mr-2"
        onClick={handleCreate}
        tooltip="Novo cadastro"
        tooltipOptions={{ position: 'right' }}
      />
      <span className="p-input-icon-left p-ml-auto">
        <i className="pi pi-search" />
        <InputText type="search" value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Pesquisar na tabela" />
      </span>
    </div>
  );

  const paginatorLeft = <Button type="button" icon="pi pi-refresh" className="p-button-text" />;
  const paginatorRight = <Button type="button" icon="pi pi-cloud" className="p-button-text" />;

  const deleteResultFooter = (
    <>
      <Button type="button" label="Não" icon="pi pi-times" className="p-button-text" onClick={hidedeleteResult} />
      <Button type="button" label="Sim" icon="pi pi-check" className="p-button-text" onClick={deleteGroup} />
    </>
  );
  const deleteResultsDialogFooter = (
    <>
      <Button type="button" label="Não" icon="pi pi-times" className="p-button-text" onClick={hidedeleteResultsDialog} />
    </>
  );

  return (
    <Container>
      <header>
        <div>
          <h1>Resultado</h1>
        </div>
      </header>

      <div className="datatable-responsive">

        <div className="card">

          <Tooltip target=".export-buttons>button" position="bottom" />

          <DataTable
            tableClassName="table-results table"
            id="table-results"
            ref={dt}
            value={results}
            editMode="row"
            dataKey="resultado_id"
            header={header}
            stripedRows
            className="p-datatable-sm"
            paginator
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords}"
            rows={50}
            rowsPerPageOptions={[10, 20, 50]}
            paginatorLeft={paginatorLeft}
            paginatorRight={paginatorRight}
            globalFilter={globalFilter}
            emptyMessage="Nenhum registro encontrado."
            selectionMode="multiple"
            selection={selectedResults}
            onSelectionChange={(e) => {
              const selResults = e.value as IResultProperties[];
              setSelectedResults(selResults);
            }}
            onRowDoubleClick={(e) => editResult(e.data)}
          >
            <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
            {dynamicColumns}
            <Column body={actionBodyTemplate} align="right" style={{ width: '120px' }} />
          </DataTable>

        </div>

        <div>
          <Dialog visible={deleteResult} style={{ width: '450px' }} header="Confirmação" modal footer={deleteResultFooter} onHide={hidedeleteResult}>
            <div className="confirmation-content">
              <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
              {result && (
              <span>
                Você tem certeza que deseja excluir
                <br />
                <br />
                <b>{result.resultado_descricao}</b>
                ?
              </span>
              )}
            </div>
          </Dialog>

          <Dialog visible={deleteResultsDialog} style={{ width: '450px' }} header="Confirmação" modal footer={deleteResultsDialogFooter} onHide={hidedeleteResultsDialog}>
            <div className="confirmation-content">
              <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
              {result
              && <span>Você tem certeza que deseja excluir os cadastros selecionados?</span>}
            </div>
          </Dialog>
        </div>

      </div>

    </Container>

  );
};

export default Result;
